import { connect } from 'react-redux';
import RetrievePassword from './RetrievePassword';
import { userForgotDetailsActionV2 } from '../../pages/travellersDetails/store/actions/UserActions';

const mapStateToProps = (state) => {
  const { user: { forgotDetails } } = state;
  return { forgotDetails };
};

const mapDispatchToProps= (dispatch) => ({
  userForgotDetailsActionV2:
    (requestType, queryParams) => dispatch(userForgotDetailsActionV2(requestType, queryParams)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RetrievePassword);
